import React, { useState, useEffect } from 'react';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Fotter';
// Placeholder images for PGVT (replace with actual PGVT image assets)
import pgvtTilesRoom1 from '../../assets/pgvt-white-tils-room1.webp';
import pgvtTilesRoom from '../../assets/pgvt-white-tils-room.avif';
import pgvtWhiteTils1 from '../../assets/pgvt-white-tils-1.avif';
import pgvtWhiteTils2 from '../../assets/pgvt-white-tils-2.webp';
import pgvtWhiteTils3 from '../../assets/pgvt-white-tils-3.webp';
import pgvtWhiteTils4 from '../../assets/pgvt-white-tils-4.jpg';
import pgvtAlainaGreyTilsRoom from '../../assets/pgvt-alaina-grey-tils-room.jpg';
import pgvtAlainaGreyTils1 from '../../assets/pgvt-alaina-grey-tils-1.webp';
import pgvtAlainaGreyTils2 from '../../assets/pgvt-alaina-grey-tils-2.png';
import pgvtAlainaGreyTils3 from '../../assets/pgvt-alaina-grey-tils-3.webp';
import pgvtAlainaGreyTils4 from '../../assets/pgvt-alaina-grey-tils-4.jpeg';
import pgvtAlexaOnyxBeigeRoom from '../../assets/pgvt-alexa-onyx-beige-room.jpg';
import pgvtAlexaOnyxBeige1 from '../../assets/pgvt-alexa-onyx-beige-tils-1.webp';
import pgvtAlexaOnyxBeige2 from '../../assets/pgvt-alexa-onyx-beige-tils-2.jpg';
import pgvtAlexaOnyxBeige3 from '../../assets/pgvt-alexa-onyx-beige-tils-3.jpg';
import pgvtAlexaOnyxBeige4 from '../../assets/pgvt-alexa-onyx-beige-tils-4.jpg';
import slab from '../../assets/slabglossy/slab.jpg';
import slab1 from '../../assets/slabglossy/slab1.jpg';
import slab2 from '../../assets/slabglossy/slab2.jpg';
import slab3 from '../../assets/slabglossy/slab3.jpg';
import slab4 from '../../assets/slabglossy/slab4.jpg';
import slab5 from '../../assets/slabglossy/slab5.jpg';
import slab6 from '../../assets/slabglossy/slab6.jpg';
import slab7 from '../../assets/slabglossy/slab7.jpg';
import slabModel from '../../assets/slabglossy/GlossyModel.jpg';
import slabModel1 from '../../assets/slabglossy/GlossyModel1.jpg';
import slabModel2 from '../../assets/slabglossy/GlossyModel2.jpg';
import slabModel3 from '../../assets/slabglossy/GlossyModel3.jpg';
import slabModel4 from '../../assets/slabglossy/GlossyModel4.jpg';
import slabModel5 from '../../assets/slabglossy/GlossyModel5.jpg';
import slabModel6 from '../../assets/slabglossy/GlossyModel6.jpg';
import slabModel7 from '../../assets/slabglossy/GlossyModel7.jpg';
import matt from '../../assets/slabmatt/matt.jpg';
import matt1 from '../../assets/slabmatt/matt1.jpg';
import matt2 from '../../assets/slabmatt/matt2.jpg';
import matt3 from '../../assets/slabmatt/matt3.jpg';
import matt4 from '../../assets/slabmatt/matt4.jpg';
import matt5 from '../../assets/slabmatt/matt5.jpg';
import matt6 from '../../assets/slabmatt/matt6.jpg';
import matt7 from '../../assets/slabmatt/matt7.jpg';
import mattModel from '../../assets/slabmatt/MattModel.jpg';
import mattModel1 from '../../assets/slabmatt/MattModel1.jpg';
import mattModel2 from '../../assets/slabmatt/MattModel2.jpg';
import mattModel3 from '../../assets/slabmatt/MattModel3.jpg';
import mattModel4 from '../../assets/slabmatt/MattModel4.jpg';
import mattModel5 from '../../assets/slabmatt/MattModel5.jpg';
import mattModel6 from '../../assets/slabmatt/MattModel6.jpg';
import mattModel7 from '../../assets/slabmatt/MattModel7.jpg';
import highGloss from '../../assets/slabhighgloss/highGloss.jpg';
import highGloss1 from '../../assets/slabhighgloss/highGloss1.jpg';
import highGloss2 from '../../assets/slabhighgloss/highGloss2.jpg';
import highGloss3 from '../../assets/slabhighgloss/highGloss3.jpg';
import highGloss4 from '../../assets/slabhighgloss/highGloss4.jpg';
import highGloss5 from '../../assets/slabhighgloss/highGloss5.jpg';
import highGloss6 from '../../assets/slabhighgloss/highGloss6.jpg';
import highGloss7 from '../../assets/slabhighgloss/highGloss7.jpg';
import highGlossModel from '../../assets/slabhighgloss/highGlossModel.png';
import highGlossModel2 from '../../assets/slabhighgloss/highGlossModel2.png';
import highGlossModel3 from '../../assets/slabhighgloss/highGlossModel3.png';
import highGlossModel4 from '../../assets/slabhighgloss/highGlossModel4.png';



const Slab = () => {
  // State for modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isImageLoading, setIsImageLoading] = useState(true);

  // State for filters
  const [selectedSize, setSelectedSize] = useState("800x200mm"); // Default size
  const [selectedFinish, setSelectedFinish] = useState("GLOSSY");

  // Available Finishes
  const availableFinishes = [
    'HIGHGLOSS', 'MATT', 'GLOSSY'
  ];
  // Function to open modal with selected image
  const openModal = (image, title, viewMode = 'single', roomScene = null) => {
    setIsImageLoading(true);
    setSelectedImage({ src: image, title, viewMode, roomScene });
    setIsModalOpen(true);
  };

  // Function to close modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
    setIsImageLoading(true);
  };

  // Handle outside click to close modal
  const handleOutsideClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  // Handle keyboard accessibility and prevent body scroll
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        closeModal();
      }
    };
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
      window.addEventListener('keydown', handleKeyDown);
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isModalOpen]);

  // PGVT tiles collection data with room scenes and individual tiles
  const pgvtCollections = [
    {
      id: 1,
      name: "ABILENCE WHITE",
      roomImage: pgvtTilesRoom,
      tileImages: [pgvtWhiteTils1, pgvtWhiteTils2, pgvtWhiteTils3, pgvtWhiteTils4,],
      size: "80x240mm",
      finish: "HIGHGLOSS",
      description: "Elegant polished white marble texture with subtle veining for luxurious spaces",
      features: ["High Gloss Finish", "Water Resistant", "Scratch Resistant", "Easy to Clean"],
    },
    {
      id: 2,
      name: "ALAINA GREY",
      roomImage: pgvtAlainaGreyTilsRoom,
      tileImages: [pgvtAlainaGreyTils1, pgvtAlainaGreyTils2, pgvtAlainaGreyTils3, pgvtAlainaGreyTils4],
      size: "120x80mm",
      finish: "GLOSSY",
      description: "Sophisticated white polished finish with a reflective surface for modern interiors",
      features: ["Stain Resistant", "High Durability", "Mirror-Like Shine", "Easy Maintenance"],
    },
    {
      id: 3,
      name: "ALEXA ONYX BEIGE",
      roomImage: pgvtAlexaOnyxBeigeRoom,
      tileImages: [pgvtAlexaOnyxBeige1, pgvtAlexaOnyxBeige2, pgvtAlexaOnyxBeige3, pgvtAlexaOnyxBeige4],
      size: "80x80mm",
      finish: "GLOSSY",
      description: "Warm beige tones with a glossy finish, perfect for elegant and cozy spaces",
      features: ["Premium Quality", "Natural Look", "Long Lasting", "Eco Friendly"],
    },

  ];

  // Slab Images for Glossy Finish (Floor-like Grid)
  const slabImages = [
    { src: slab, title: 'ASTARDA BLUE', roomScene: slabModel },
    { src: slab1, title: 'ASTARDA CREMA', roomScene: slabModel1 },
    { src: slab2, title: 'ASTARDA GRAY', roomScene: slabModel2 },
    { src: slab3, title: 'ASTARDA NERO', roomScene: slabModel3 },
    { src: slab4, title: 'ASTILIO BROWN', roomScene: slabModel4 },
    { src: slab5, title: 'ASTILIO CREMA', roomScene: slabModel5 },
    { src: slab6, title: 'ASTILIO GREY', roomScene: slabModel6 },
    { src: slab7, title: 'ASTILIO WHITE', roomScene: slabModel7 },
  ];

  // Matt Images for Matt Finish
  const mattImages = [
    { src: matt, title: 'ARIA NERO' },
    { src: matt1, title: 'ARIA ROSATA' },
    { src: matt2, title: 'ARIA WHITE' },
    { src: matt3, title: 'ASCAP BIANCO', roomScene: mattModel3 },
    { src: matt4, title: 'ASCAP GREY', roomScene: mattModel4 },
    { src: matt5, title: 'AVERY BEIGE', roomScene: mattModel5 },
    { src: matt6, title: 'AVERY BIANCO', roomScene: mattModel6 },
    { src: matt7, title: 'AVERY BROWN', roomScene: mattModel7 },
  ];

  // High Gloss Images for High Gloss Finish
  const HIGHGLOSS = [
    { src: highGloss, title: 'STELLAR BLACK', roomScene: highGlossModel },
    { src: highGloss1, title: 'TERRAZZO BLACK' },
    { src: highGloss2, title: 'TERRAZZO BROWN', roomScene: highGlossModel2 },
    { src: highGloss3, title: 'TERRAZZO CREMA', roomScene: highGlossModel3 },
    { src: highGloss4, title: 'TERRAZZO DARK GRAY', roomScene: highGlossModel4 },
    { src: highGloss5, title: 'MARMO FOREST' },
    { src: highGloss6, title: 'STELLAR CREMA' },
    { src: highGloss7, title: 'RIVIERA NATURAL' },
  ];

  const pgvtCategory = {
    fullName: "Polished Glazed Vitrified Tiles",
    description:
      "Premium polished glazed vitrified tiles offering a mirror-like finish with exceptional durability and elegance.",
    features: ["Water Absorption < 0.5%", "High Gloss Finish", "Stain Resistant", "Low Maintenance"],
    sizes: ["800x200mm", "800x3200mm", "1200x2400mm", "1200x3200mm"],
  };

  // Filter collections based on selected size and finish
  const filteredCollections = pgvtCollections.filter(collection => {
    // Logic: If a filter is selected, the item must match.
    if (selectedSize && collection.size !== selectedSize) return false;
    if (selectedFinish && collection.finish !== selectedFinish) return false;
    return true;
  });

  const showResults = true; // Always show even if empty, or handle empty state within map

  return (
    <div className="w-full overflow-hidden">
      {/* Navbar */}
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[50vh] sm:h-[60vh] md:h-[70vh] lg:h-[80vh] bg-gradient-to-r from-gray-900 via-gray-800 to-orange-900">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${pgvtTilesRoom1})` }}
        ></div>
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="text-center text-white max-w-full sm:max-w-2xl md:max-w-3xl lg:max-w-4xl px-4 sm:px-6">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-orange-500 mb-4 sm:mb-6 drop-shadow-2xl">
              Slab Collection
            </h1>
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl font-light">
              {pgvtCategory.fullName}
            </p>
            <div className="mt-4 sm:mt-6 w-24 sm:w-28 lg:w-32 h-1 bg-orange-500 mx-auto"></div>
          </div>
        </div>
      </section>

      {/* Product Info Section */}
      <section className="py-8 sm:py-12 lg:py-16 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12 lg:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb-4">
              Premium <span className="text-orange-600">Slab Tiles</span>
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl sm:max-w-3xl lg:max-w-4xl mx-auto mb-6 sm:mb-8 leading-relaxed">
              {pgvtCategory.description} Our Slab tiles combine advanced polishing techniques with stunning designs to create surfaces that elevate any space with a luxurious shine.
            </p>
            {/* Features */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 max-w-5xl mx-auto">
              {pgvtCategory.features.map((feature, index) => (
                <div
                  key={index}
                  className="bg-gradient-to-br from-orange-50 to-orange-100 p-4 sm:p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                >
                  <div className="bg-orange-600 text-white text-lg sm:text-xl md:text-2xl w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                    ✓
                  </div>
                  <p className="text-gray-800 font-semibold text-sm sm:text-base md:text-lg">{feature}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* NEW FILTER SECTION */}
      <section className="py-8 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-1">
          <div className="bg-white rounded-[2rem] p-6 sm:p-8 md:p-12 shadow-xl border border-gray-100">
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-16">

              {/* Size Selection */}
              <div className="lg:w-1/3">
                <h3 className="text-gray-800 text-xl sm:text-2xl font-medium mb-6">Choose By Size</h3>
                <div className="flex flex-col gap-4">
                  {pgvtCategory.sizes.map((size) => (
                    <button
                      key={size}
                      onClick={() => setSelectedSize(selectedSize === size ? null : size)}
                      className={`
                        w-full py-4 px-6 rounded-xl text-lg font-bold transition-all duration-300 border
                        ${selectedSize === size
                          ? 'bg-orange-600 text-white border-orange-600 shadow-lg scale-105'
                          : 'bg-white border-gray-200 text-gray-600 hover:border-orange-200 hover:bg-orange-50'}
                      `}
                    >
                      {size.toUpperCase()}
                    </button>
                  ))}
                </div>
              </div>

              {/* Vertical Divider (Visible on Large Screens) */}
              <div className="hidden lg:block w-px bg-gray-200 my-2"></div>

              {/* Horizontal Divider (Visible on Small Screens) */}
              <div className="block lg:hidden h-px w-full bg-gray-200"></div>

              {/* Finish Selection */}
              <div className="lg:w-2/3">
                <h3 className="text-gray-800 text-xl sm:text-2xl font-medium mb-6">Choose By Finish</h3>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4">
                  {availableFinishes.map((finish) => (
                    <button
                      key={finish}
                      onClick={() => setSelectedFinish(selectedFinish === finish ? null : finish)}
                      className={`
                        py-3 px-2 sm:px-4 rounded-xl text-xs sm:text-sm font-bold transition-all duration-300 h-16 sm:h-20 flex items-center justify-center text-center border
                        ${selectedFinish === finish
                          ? 'bg-orange-600 text-white border-orange-600 shadow-lg scale-105'
                          : 'bg-white border-gray-200 text-gray-600 hover:border-orange-200 hover:bg-orange-50'}
                      `}
                    >
                      {finish}
                    </button>
                  ))}
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* Results Section */}
      {/* Matt Collection Grid */}
      {selectedFinish === 'MATT' && (
        <section className="py-8 sm:py-12 bg-white animate-fade-in">
          <div className="container mx-auto px-4 sm:px-6">
            <div className="text-center mb-8">
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
                Matt Series <span className="text-orange-600">Collection</span>
              </h3>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Discover the elegant and extensive range of our Matt finish tiles.
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">
              {mattImages.map((img, index) => (
                <div
                  key={index}
                  className="group relative cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 bg-white"
                  onClick={() => openModal(img.src, img.title, 'detail', img.roomScene)}
                >
                  <div className="aspect-[2/3] overflow-hidden relative">
                    <img
                      src={img.src}
                      alt={img.title}
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300"></div>
                  </div>

                  {/* Image Details */}
                  <div className="p-4 text-center">
                    <h4 className="text-gray-800 font-bold text-lg mb-1">{img.title}</h4>
                    <p className="text-gray-500 text-sm mb-1">{selectedSize ? `Size: ${selectedSize}` : 'Matt Collection'}</p>
                    <span className="inline-block bg-orange-100 text-orange-800 text-xs px-2 py-1 rounded-full font-semibold">
                      Matt Finish
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* High Gloss Collection Grid */}
      {selectedFinish === 'HIGHGLOSS' && (
        <section className="py-8 sm:py-12 bg-white animate-fade-in">
          <div className="container mx-auto px-4 sm:px-6">
            <div className="text-center mb-8">
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
                High Gloss Series <span className="text-orange-600">Collection</span>
              </h3>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Experience the mirror-like shine and premium luxury of our High Gloss finish slabs.
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">
              {HIGHGLOSS.map((img, index) => (
                <div
                  key={index}
                  className="group relative cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 bg-white"
                  onClick={() => openModal(img.src, img.title, 'detail', img.roomScene)}
                >
                  <div className="aspect-[2/3] overflow-hidden relative">
                    <img
                      src={img.src}
                      alt={img.title}
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300"></div>
                  </div>

                  {/* Image Details */}
                  <div className="p-4 text-center">
                    <h4 className="text-gray-800 font-bold text-lg mb-1">{img.title}</h4>
                    <p className="text-gray-500 text-sm mb-1">{selectedSize ? `Size: ${selectedSize}` : 'High Gloss Collection'}</p>
                    <span className="inline-block bg-orange-100 text-orange-800 text-xs px-2 py-1 rounded-full font-semibold">
                      High Gloss Finish
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Glossy Collection Grid */}
      {selectedFinish === 'GLOSSY' ? (
        <section className="py-8 sm:py-12 bg-white animate-fade-in">
          <div className="container mx-auto px-4 sm:px-6">
            <div className="text-center mb-8">
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
                Glossy Series <span className="text-orange-600">Collection</span>
              </h3>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Discover the elegant and extensive range of our Glossy finish tiles.
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">
              {slabImages.map((img, index) => (
                <div
                  key={index}
                  className="group relative cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 bg-white"
                  onClick={() => openModal(img.src, img.title, 'detail', img.roomScene)}
                >
                  <div className="aspect-[2/3] overflow-hidden relative">
                    <img
                      src={img.src}
                      alt={img.title}
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300"></div>
                  </div>

                  {/* Image Details */}
                  <div className="p-4 text-center">
                    <h4 className="text-gray-800 font-bold text-lg mb-1">{img.title}</h4>
                    <p className="text-gray-500 text-sm mb-1">{selectedSize ? `Size: ${selectedSize}` : 'Glossy Collection'}</p>
                    <span className="inline-block bg-orange-100 text-orange-800 text-xs px-2 py-1 rounded-full font-semibold">
                      Glossy Finish
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      ) : showResults && (
        <section className="py-8 sm:py-12 bg-gray-50 min-h-[500px]">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between mb-8 sm:mb-12">
              <div className="text-left w-full">
                <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800">
                  <span className="text-orange-600">Selected</span> Collections
                </h2>
                <div className="mt-2 text-gray-600">
                  Showing results for:
                  {selectedSize && <span className="ml-2 px-3 py-1 bg-orange-100 text-orange-800 rounded-full text-sm font-medium">{selectedSize}</span>}
                  {selectedFinish && <span className="ml-2 px-3 py-1 bg-gray-200 text-gray-800 rounded-full text-sm font-medium">{selectedFinish}</span>}
                </div>
              </div>
            </div>

            <div className="space-y-8 sm:space-y-10 lg:space-y-12">
              {filteredCollections.length > 0 ? (
                filteredCollections.map((collection) => (
                  <div key={collection.id} className="bg-white rounded-xl shadow-2xl overflow-hidden animate-fade-in-up">
                    {/* Collection Header */}
                    <div className="bg-gradient-to-r from-orange-600 to-orange-700 text-white p-4 sm:p-6">
                      <h3 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-center">{collection.name}</h3>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 sm:gap-6 p-4 sm:p-6">
                      {/* Left Side - Room Scene */}
                      <div className="lg:col-span-1 relative group">
                        <div className="relative w-full aspect-square overflow-hidden rounded-2xl">
                          <img
                            src={collection.roomImage}
                            alt={`${collection.name} room scene`}
                            className="w-full h-full object-cover rounded-2xl group-hover:scale-105 transition-transform duration-500"
                            loading="lazy"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl"></div>
                          <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                            <h4 className="text-sm sm:text-base md:text-lg font-bold mb-1">{collection.name}</h4>
                            <p className="text-xs bg-black/50 px-2 py-1 rounded-full">Room Application</p>
                          </div>
                          <button
                            onClick={() => openModal(collection.roomImage, `${collection.name} - Room Scene`)}
                            className="absolute top-2 sm:top-3 right-2 sm:right-3 bg-white/90 text-gray-800 p-1.5 sm:p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 hover:bg-white shadow-md"
                          >
                            🔍
                          </button>
                        </div>
                      </div>

                      {/* Right Side - Tiles Images */}
                      <div className="lg:col-span-3">
                        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4">
                          {collection.tileImages.slice(0, 4).map((tileImage, tileIndex) => (
                            <div key={tileIndex} className="relative group/tile cursor-pointer">
                              <div className="aspect-square relative overflow-hidden rounded-2xl shadow-md">
                                <img
                                  src={tileImage}
                                  alt={`${collection.name} tile design ${tileIndex + 1}`}
                                  className="w-full h-full object-cover group-hover/tile:scale-110 transition-transform duration-300 rounded-2xl"
                                  onClick={() => openModal(tileImage, `${collection.name} - Design ${tileIndex + 1}`, 'detail', collection.roomImage)}
                                  loading="lazy"
                                />
                                <div className="absolute inset-0 bg-black/0 group-hover/tile:bg-black/20 transition-colors duration-300 rounded-2xl"></div>
                                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover/tile:opacity-100 transition-opacity duration-300">
                                  <div className="bg-white/90 text-gray-800 p-1.5 sm:p-2 rounded-full shadow-md">
                                    🔍
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                        {/* Collection Details */}
                        <div className="mt-4 sm:mt-6">
                          <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4 leading-relaxed">{collection.description}</p>
                          <div className="flex flex-wrap gap-2 sm:gap-3 mb-3 sm:mb-4">
                            <span className="bg-orange-100 text-orange-800 text-xs sm:text-sm px-2 sm:px-3 py-1 rounded-full">
                              Size: {collection.size}
                            </span>
                            <span className="bg-orange-100 text-orange-800 text-xs sm:text-sm px-2 sm:px-3 py-1 rounded-full">
                              Finish: {collection.finish}
                            </span>
                          </div>
                          <ul className="text-sm sm:text-base text-gray-600 space-y-1 sm:space-y-2">
                            {collection.features.map((feature, index) => (
                              <li key={index} className="flex items-center">
                                <span className="text-orange-600 mr-2">✓</span> {feature}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center py-10 text-gray-500">
                  <p className="text-xl">No collections found matching your selection.</p>
                  <p className="mt-2 text-sm">Try adjusting your size or finish filters.</p>
                </div>
              )}
            </div>
          </div>
        </section>
      )}

      {/* Available Sizes Section */}
      <section className="py-8 sm:py-12 lg:py-16 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb-4">
              Available <span className="text-orange-600">Sizes</span>
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4 lg:gap-6 max-w-2xl sm:max-w-3xl lg:max-w-4xl mx-auto">
              {pgvtCategory.sizes.map((size, index) => (
                <div
                  key={index}
                  className="bg-gradient-to-br from-orange-100 to-orange-200 text-orange-800 font-bold py-3 sm:py-4 px-4 sm:px-6 rounded-xl text-center shadow-lg hover:shadow-xl transition-shadow duration-300 transform hover:-translate-y-1"
                >
                  <div className="text-lg sm:text-xl md:text-2xl mb-1 sm:mb-2">📏</div>
                  <div className="text-sm sm:text-base md:text-lg">{size}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Technical Specifications */}
      <section className="py-8 sm:py-12 lg:py-16 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb-4">
              Technical <span className="text-orange-600">Specifications</span>
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 max-w-2xl sm:max-w-4xl lg:max-w-6xl mx-auto">
            {[
              { icon: "💧", title: "Water Absorption", desc: "Less than 0.5% as per IS 15622" },
              { icon: "💪", title: "Breaking Strength", desc: "Minimum 2000N as per IS 15622" },
              { icon: "✨", title: "Surface Gloss", desc: "High-gloss polished finish for reflective shine" },
            ].map((spec, index) => (
              <div key={index} className="bg-white p-4 sm:p-6 rounded-xl shadow-lg">
                <div className="text-orange-600 text-2xl sm:text-3xl md:text-4xl mb-3 sm:mb-4 text-center">{spec.icon}</div>
                <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-800 mb-2 text-center">{spec.title}</h3>
                <p className="text-sm sm:text-base text-gray-600 text-center">{spec.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-8 sm:py-12 lg:py-16 bg-gradient-to-r from-orange-600 to-orange-700">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3 sm:mb-4">
            Transform Your Space Today
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-orange-100 mb-6 sm:mb-8 max-w-2xl sm:max-w-3xl mx-auto leading-relaxed">
            Contact our design experts to find the perfect Slab tiles for your project. Get personalized recommendations and professional installation support.
          </p>
        </div>
      </section>

      {isModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-2 sm:p-4"
          onClick={handleOutsideClick}
        >
          <div className={`relative w-full mx-auto outline-none ${selectedImage.viewMode === 'detail' ? 'max-w-7xl' : 'max-w-5xl'}`}>

            {selectedImage.viewMode === 'detail' ? (
              // Detailed Product Modal
              <div className="bg-white rounded-xl overflow-hidden shadow-2xl max-h-[90vh] overflow-y-auto">
                {/* Header */}
                <div className="bg-orange-600 p-4 sm:p-6 text-center relative">
                  <h2 className="text-white text-xl sm:text-3xl font-bold uppercase tracking-wider">{selectedImage.title}</h2>
                  <button
                    onClick={closeModal}
                    className="absolute top-1/2 -translate-y-1/2 right-4 sm:right-6 text-white hover:text-orange-200 transition-colors text-2xl font-bold"
                  >
                    ✕
                  </button>
                </div>

                <div className="flex flex-col lg:flex-row">
                  {/* Left: Room Scene */}
                  {selectedImage.roomScene && (
                    <div className="lg:w-1/2 p-6 bg-gray-50 flex items-center justify-center">
                      <img
                        src={selectedImage.roomScene}
                        alt="Room Scene"
                        className="w-full h-full rounded-lg shadow-md object-cover max-h-[500px]"
                      />
                    </div>
                  )}

                  {/* Right: Faces & Info */}
                  <div className={`${selectedImage.roomScene ? 'lg:w-1/2' : 'w-full'} p-6 flex flex-col`}>
                    {/* Faces Grid */}
                    <div className="grid grid-cols-4 gap-3 mb-8">
                      {[1, 2, 3, 4].map((_, i) => (
                        <div key={i} className="aspect-[3/4] rounded-lg overflow-hidden border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                          <img src={selectedImage.src} alt={`Face ${i + 1}`} className="w-full h-full object-cover" />
                        </div>
                      ))}
                    </div>

                    {/* Product Info */}
                    <div>
                      <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                        Premium polished glazed vitrified tiles offering a mirror-like finish with exceptional durability and elegance.
                        Perfect for both residential and commercial applications.
                      </p>

                      <div className="flex flex-wrap gap-3 mb-6">
                        <span className="bg-orange-100 text-orange-800 px-4 py-2 rounded-full font-semibold">
                          Size: {selectedSize || "Standard"}
                        </span>
                        <span className="bg-orange-100 text-orange-800 px-4 py-2 rounded-full font-semibold">
                          Finish: {selectedFinish || "Polished"}
                        </span>
                      </div>

                      <div className="space-y-2">
                        {['High Strength', 'Water Resistant', 'Stain Resistant', 'Easy Maintenance'].map((feat, i) => (
                          <div key={i} className="flex items-center text-gray-700">
                            <span className="text-orange-600 mr-2">✓</span>
                            {feat}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              // Simple Zoom Modal
              <div className="relative flex flex-col items-center justify-center">
                {isImageLoading && (
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 sm:w-14 lg:w-16 h-12 sm:h-14 lg:h-16 border-4 border-orange-600 border-t-transparent rounded-full animate-spin"></div>
                  </div>
                )}
                <img
                  src={selectedImage.src}
                  alt={`Zoomed view of ${selectedImage.title}`}
                  className="w-full h-auto max-h-[90vh] object-contain rounded-lg shadow-2xl"
                  onLoad={() => setIsImageLoading(false)}
                />
                <button
                  onClick={closeModal}
                  className="absolute top-2 sm:top-3 right-2 sm:right-3 bg-white text-black rounded-full p-2 sm:p-3 hover:bg-gray-200 transition-all duration-300 text-base sm:text-lg lg:text-xl font-bold shadow-lg"
                >
                  ✕
                </button>
                {selectedImage && !isImageLoading && (
                  <div className="absolute bottom-2 sm:bottom-3 left-2 sm:left-4 bg-black/70 text-white px-3 sm:px-4 py-1 sm:py-2 rounded-lg">
                    <h3 className="text-sm sm:text-base md:text-lg font-bold">{selectedImage.title}</h3>
                  </div>
                )}
              </div>
            )}

          </div>
        </div>
      )}

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Slab;